



















import { Vue, Prop, Component } from 'vue-property-decorator';
@Component
export default class Comment extends Vue {
  @Prop() commentData!: object;
}
